import { createAction, props } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { PromptRegisterListItem } from '../models/prompt-register-results.model';
import { PromptsFilterOption } from '../models/prompts-filter-option';

const area = 'Prompt Register';
export const promptRegisterAdapterActions = createRegisterActions<PromptRegisterListItem>(area);

export const createPrompt = createAction(`[${area}] Create Prompt`);

export const promptRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: PromptsFilterOption[] }>()
);

export const setOrderingOptionsFromSessionStorage = createAction(
   `[${area}] Set Ordering Options From Session Storage`,
   props<{ orderingOptions: OrderingOption[] | null }>()
);
